// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uploadContainer {
    background-color: white;
    display: flex;
    padding: 20px 52px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
}

.title {
    font-size: 20px;
    font-weight: 700;
    text-align: center;
    color: #3d3d3d;
}

input[type="file"] {
    /* display: none; */
    display: none;
}

/* hide no file choosen */
.inputLabel {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    border-radius: 20px;
    padding: 12px 0px;
    height: 170px;
    border: 3px dashed #9C9C9C;
    margin: 20px 0px;
    margin-top: 28px;
    width: 340px;
    position: relative;
}

.dragBtnContainer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1 1;
    height: 100%;
}

.dragSelectedBtnContainer {
    display: flex;
    /* flex-direction: column; */
    justify-content: center;
    align-items: center;
    flex: 1 1;
    gap: 12px;
    height: 100%;
}

.dragFile {
    font-size: 14px;
    font-weight: 500;
    color: #7B7B7B;
    text-align: center;
    word-break: break-all;
    white-space: normal;
}

.browseFileBtn {
    border-radius: 16px;
    border: 1px solid #5A4BDA;
    color: #5A4BDA;
    padding: 4px 32px;
    background-color: white;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    outline: none;
    margin-top: 6px;
    margin-bottom: 32px;
}

.maxFile {
    font-size: 12px;
    font-weight: 500;
    color: #7B7B7B;
    text-align: center;
    margin-top: 4px;
    white-space: normal;
}

.maxFileType {
    font-size: 12px;
    font-weight: 700;
    color: #7B7B7B;
    text-align: center;
    margin-top: 4px;
    white-space: normal;
}

.uploadBtn {
    background-color: #EBE9E9;
    border-radius: 8px;
    color: #3D3D3D;
    padding: 10px 42px;
    font-size: 14px;
    font-weight: 400;
    cursor: pointer;
    outline: none;
    border: none;
}

.uploadBtn.uploading {
    background-color: #5A4BDA;
    color: white;
}

.uploadBtn.uploaded {
    background-color: #3FB422;
    color: white;
}

.uploadBtnContainer.show {
    margin-top: 10px;
    border-radius: 8px;
    /* margin-top: 20px; */
    width: 100%;
    background-color: #D0CAFF;
}

/* .dragBottom{
    position: absolute;
    bottom: 12px;
} */

.fileName {
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    text-decoration: underline;
    color: #7B7B7B;
    /* margin-top: 10px; */
    word-break: break-all;
    white-space: normal;
}

.copyPara {
    font-size: 18px;
    font-weight: 600;
    margin-top: 24px;
    color: #3D3D3D;
}

.copyPara>span {
    display: flex;
    cursor: pointer;
    display: inline-block;
    justify-content: center;
    align-content: center;
    color: #5A4BDA;
    text-decoration: underline;
}

@media only screen and (max-width: 500px) {
    .inputLabel {
        width: 100%;
        padding: 10px 16px;
    }

    .uploadContainer {
        padding: 20px 40px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/upload/Upload.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,aAAa;AACjB;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,0BAA0B;IAC1B,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,4BAA4B;IAC5B,uBAAuB;IACvB,mBAAmB;IACnB,SAAO;IACP,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;;;GAGG;;AAEH;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,0BAA0B;IAC1B,cAAc;IACd,sBAAsB;IACtB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,uBAAuB;IACvB,qBAAqB;IACrB,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI;QACI,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":[".uploadContainer {\n    background-color: white;\n    display: flex;\n    padding: 20px 52px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    border-radius: 20px;\n}\n\n.title {\n    font-size: 20px;\n    font-weight: 700;\n    text-align: center;\n    color: #3d3d3d;\n}\n\ninput[type=\"file\"] {\n    /* display: none; */\n    display: none;\n}\n\n/* hide no file choosen */\n.inputLabel {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n    border-radius: 20px;\n    padding: 12px 0px;\n    height: 170px;\n    border: 3px dashed #9C9C9C;\n    margin: 20px 0px;\n    margin-top: 28px;\n    width: 340px;\n    position: relative;\n}\n\n.dragBtnContainer {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    flex: 1;\n    height: 100%;\n}\n\n.dragSelectedBtnContainer {\n    display: flex;\n    /* flex-direction: column; */\n    justify-content: center;\n    align-items: center;\n    flex: 1;\n    gap: 12px;\n    height: 100%;\n}\n\n.dragFile {\n    font-size: 14px;\n    font-weight: 500;\n    color: #7B7B7B;\n    text-align: center;\n    word-break: break-all;\n    white-space: normal;\n}\n\n.browseFileBtn {\n    border-radius: 16px;\n    border: 1px solid #5A4BDA;\n    color: #5A4BDA;\n    padding: 4px 32px;\n    background-color: white;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    outline: none;\n    margin-top: 6px;\n    margin-bottom: 32px;\n}\n\n.maxFile {\n    font-size: 12px;\n    font-weight: 500;\n    color: #7B7B7B;\n    text-align: center;\n    margin-top: 4px;\n    white-space: normal;\n}\n\n.maxFileType {\n    font-size: 12px;\n    font-weight: 700;\n    color: #7B7B7B;\n    text-align: center;\n    margin-top: 4px;\n    white-space: normal;\n}\n\n.uploadBtn {\n    background-color: #EBE9E9;\n    border-radius: 8px;\n    color: #3D3D3D;\n    padding: 10px 42px;\n    font-size: 14px;\n    font-weight: 400;\n    cursor: pointer;\n    outline: none;\n    border: none;\n}\n\n.uploadBtn.uploading {\n    background-color: #5A4BDA;\n    color: white;\n}\n\n.uploadBtn.uploaded {\n    background-color: #3FB422;\n    color: white;\n}\n\n.uploadBtnContainer.show {\n    margin-top: 10px;\n    border-radius: 8px;\n    /* margin-top: 20px; */\n    width: 100%;\n    background-color: #D0CAFF;\n}\n\n/* .dragBottom{\n    position: absolute;\n    bottom: 12px;\n} */\n\n.fileName {\n    font-size: 14px;\n    font-weight: 500;\n    text-align: center;\n    text-decoration: underline;\n    color: #7B7B7B;\n    /* margin-top: 10px; */\n    word-break: break-all;\n    white-space: normal;\n}\n\n.copyPara {\n    font-size: 18px;\n    font-weight: 600;\n    margin-top: 24px;\n    color: #3D3D3D;\n}\n\n.copyPara>span {\n    display: flex;\n    cursor: pointer;\n    display: inline-block;\n    justify-content: center;\n    align-content: center;\n    color: #5A4BDA;\n    text-decoration: underline;\n}\n\n@media only screen and (max-width: 500px) {\n    .inputLabel {\n        width: 100%;\n        padding: 10px 16px;\n    }\n\n    .uploadContainer {\n        padding: 20px 40px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
